<template>
  <div>
    <div>
      <div class="WorkM_ApprovalConditionArea px-0 py-2 d-flex" style="display: flex; flex-wrap:wrap;">
        <b-button-group class="d-flex text-center align-middle" size="sm">
          <b-button class="px-1" variant="outline-success" @click="approvalAllRows">全承認</b-button>
          <label class="spacer"></label>
          <b-button class="px-1" variant="outline-danger" @click="rejectionAllRows">全否認</b-button>
          <label class="spacer"></label>
          <b-button class="px-1" variant="outline-secondary" @click="uncheckAllRows">選択解除</b-button>
        </b-button-group>
        <div class="d-flex align-items-center" v-if="workList.length > 0">（ 全 {{ workList.length }} 件 ）</div>
      </div>
      <!-- 一覧 -->
      <div class="WorkM_ApprovalWorkListArea">
        <div v-if="!listEmptyCheck(workList)" class="mt-3">
          <div v-for="workItem in workList" :key="[workItem.workDate,workItem.shainCd].join('-')" >
            <div class="WorkM_ApprovalWorkItem">
              <!--リスト左側-->
              <div class="WorkM_WorkApplicationItem_HeaderArea">
                <div class="ApprovalWorkSelectArea mt-3">
                  <div class="ApprovalLabel" style="color:rgb(20,78,34)">
                    <b-form-checkbox size="sm" v-model="workItem.approvalKbn" value=1 @change="applicationCount">
                      承認
                    </b-form-checkbox>
                  </div>
                  <div class="RejectionLabel" style="color:red;">
                    <b-form-checkbox size="sm" v-model="workItem.approvalKbn" value=9 @change="applicationCount">
                      否認
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
              <div class="WorkM_ApprovalWorkItem_DetailArea" @click="openApplicationEditModal(workItem)" style="cursor: pointer;">
                <!--リスト右側-->
                <div style="margin-bottom:5px">
                  <div class="ApprovalDetailItem">
                    <div class="ApprovalDate" style="height: 25px;">
                      <div v-if="!emptyCheck(workItem.shainName)" class="mr-3 d-flex align-items-center" style="white-space: nowrap;">{{ "" + workItem.shainName + ""}}</div>
                    </div>
                    <div class="ApprovalDetailItem" style="font-weight: 400; flex-wrap: wrap; font-size:0.85rem;">
                        <div v-if="!emptyCheck(workItem.departmentName) && !emptyCheck(workItem.sectionName)" class="mr-2 d-flex align-items-center ApprovalDetailItemConstruction">
                          {{ "" + workItem.departmentName + " " + workItem.sectionName + ""}}
                        </div>
                    </div>
                  </div>
                  <div class="ApprovalDate ApprovalDateApprovalApplication" style="flex-wrap:wrap;">
                    <div style="min-width:30px;" v-if="!emptyCheck(workItem.workDate)" class="mr-2 d-flex align-items-center">{{ "" + workItem.workDate + "" }}</div>
                    <div style="min-width:30px;" v-if="!emptyCheck(workItem.shiftStart) && !emptyCheck(workItem.shiftEnd)" class=" d-flex align-items-center">
                      {{ workItem.startTime + "～" + workItem.endTime }}
                    </div>
                  </div>
                </div>
                <div v-for="workInfoItem in workItem.workInfoList" :key="workInfoItem.detailNo">
                  <div class="ApprovalDetailItem">
                    <div
                      v-if="!emptyCheck(workInfoItem.workSegment)"
                      class="WorkContent_ItemTypeArea_TypeLabel text-center WorkApplication_Overtime2"
                      :class="[
                        { WorkApplication_Transfer2: isAttendanceCheck(workInfoItem.workSegment) },
                        { WorkApplication_Allowance2: !isAttendanceCheck(workInfoItem.workSegment) && workInfoItem.workSegment != 1 && workInfoItem.workSegment != 2  },
                      ]"
                      style="min-width:110px"
                    >
                      {{ workInfoItem.workSegmentLabel }}
                    </div>
                    <div v-if="!emptyCheck(workInfoItem.startTime) && !emptyCheck(workInfoItem.endTime)" class="ml-2" style="white-space: nowrap">
                      {{ workInfoItem.startTime + "～" + workInfoItem.endTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mt-3 mb-1 border rounded-sm explainArea">
          <div>
            <label class="mb-0">承認対象の報告はありません。</label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between fixed-bottom px-3 ApprovalFooter">
        <div class="d-flex my-2 mx-auto">
          <!-- ボタン -->
          <div class="WorkM_WorkRegistButtonArea">
            <b-button :disabled="listEmptyCheck(workList)" class="WorkM_Button btn-secondary px-5" @click="sendWorkMail">確定</b-button>
          </div>
        </div>
          <div class="my-1" style="position:absolute;right:10px;background-color: transparent;">
            <div class="mx-1" style="font-size: 0.85rem">承認 {{countApproval}}件</div>
            <div class="mx-1" style="font-size: 0.85rem">否認 {{countRejection}}件</div>
          </div>
      </div>

    </div>
    
    <WorkViewModal 
    ref="WorkViewModal"
    :selectApplication="selectApplication"
    :shainName="shainName"
    :approvalUserName="approvalUserName"
    ></WorkViewModal>
  </div>
</template>
<script>
import config from "../../const/config"
import WorkViewModal from "../Modal/WorkViewModal.vue";
export default {
  name: "WorkApplication",
  components: { WorkViewModal },
  data() {
    return {
      workList: [],
      statusType: 0,
      optionStatus: [
        {
          value: 0,text: "すべて"
        },
        {
          value: 1,text: "未承認"
        },
        {
          value: 2,text: "代理承認"
        },
        {
          value: 3,text: "承認済"
        },
      ],
      countApproval: 0,
      countRejection: 0,
      countNonApproval: 0,
      selectApplication: {},
      shainName: "",
      approvalUserName: "",
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
  },

  methods: {
    // 押下した箇所に合わせて、開くモーダルのタイトルを変更する
    // clickType:0 申請一覧を押下した際の動作。申請更新モーダルを開く
    // clickType:0以外 追加ボタンを押下した際の動作。申請登録モーダルを開く
    openApplicationEditModal: function (approvalItem) {
      console.debug("approvalItem：" + JSON.stringify(approvalItem));
      this.shainName = approvalItem.shainName;
      this.approvalUserName = approvalItem.approvalShainName;
      this.getWorkScheduleInfo(approvalItem.shainCd, approvalItem.workDate);
    },

    getWorkScheduleInfo: function(shainCd, targetDate){
      let paramList = {
          shainCd: shainCd,
          targetDate: targetDate
      }
      this.getWithParams(config.URL.APPROVAL_REGIST_WORK + "/fromApprove", paramList)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          console.debug("response：" + JSON.stringify(response));
          this.selectApplication = response.container
          this.$refs.WorkViewModal.openModal();
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
        },

    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.APPLICATION_SEGMENT_SIMPLE;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      this.applicationCount();
      return result;
    },
    // 報告承認情報を取得する
    getApprovalWorkInfo: function(){
      console.log("call getApprovalWorkInfo");
      this.getApprovalWorkInfoAPI();
    },
    getApprovalWorkInfoAPI: function(){
      let paramList = {
        shainCd: this.loginUserId,
      };
      console.debug("paramList：" + JSON.stringify(paramList));
      this.getWithParams(config.URL.APPROVAL_REGIST_WORK, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setApprovalWorkInfo(response.container);
          }
          else{
            this.showAlertErrorHTML(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {
          this.applicationCount();
        });
    },
    setApprovalWorkInfo: function(item){
      this.workList = item.approvalSummaryList;
    },
    // 全承認機能
    approvalAllRows: function(){
      if(this.listEmptyCheck(this.workList)){
        return;
      }
      this.workList.forEach((element) => {
        element.approvalKbn = 1;
      });
      this.applicationCount();
    },
    // 全否認機能
    rejectionAllRows: function(){
      if(this.listEmptyCheck(this.workList)){
        return;
      }
      this.workList.forEach((element) => {
        element.approvalKbn = 9;
      });
      this.applicationCount();
    },
    // 選択解除機能
    uncheckAllRows: function(){
      if(this.listEmptyCheck(this.workList)){
        return;
      }
      this.workList.forEach((element) => {
        element.approvalKbn = 0;
      });
      this.applicationCount();
    },
    // 承認・否認件数チェック
    applicationCount: function(){
      console.log("call applicationCount");
      let countApproval = this.workList.filter((value) => {
        return value.approvalKbn == 1;
      });
      let countRejection = this.workList.filter((value) => {
        return value.approvalKbn == 9;
      });
      let countNonApproval = this.workList.filter((value) => {
        return value.approvalKbn != 1 && value.approvalKbn != 9;
      });
      this.countApproval = countApproval.length;
      this.countRejection = countRejection.length;
      this.countNonApproval = countNonApproval.length;
    },
    // 確定処理
    sendWorkMail: function(){
      if(this.countApproval <= 0 && this.countRejection <= 0){
        this.showAlertErrorHTML("承認・否認する申請を選択してください。");
        return;
      }

      // 承認結果が承認、または否認の項目を抽出
      let countApproval = this.workList.filter((value) => {
        return value.approvalKbn == 1 || value.approvalKbn == 9;
      });

      // 登録する内容一覧を生成
      let userId = this.loginUserId;
      let registList = [];
      countApproval.forEach(function(approval){
        let registItem = {
          workingShainCd:approval.shainCd,
          workDate:approval.workDate,
          approvalKbn:approval.approvalKbn,
          approvalShainCd:userId,
        }
        registList.push(registItem);
      });

      // 送信前のパラメータ設定
      let json = {
        approvalList: registList,
      };
      console.log("json：" + JSON.stringify(json));

      let message = "以下の内容で承認を確定します。"
      + "<br>・承認：" + this.countApproval + " 件"
      + "<br>・否認：" + this.countRejection + " 件"
      if(this.countNonApproval > 0){
        message = message + "<br> <label style='color:red;'>＊未設定が " + this.countNonApproval + " 件あります。</label>";
      }
      message = message + "<br>よろしいですか？";
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
        // 新規登録
        this.postData(config.URL.APPROVAL_REGIST_WORK, json)
          .then((response) => {
            console.debug("response：" + JSON.stringify(response));
            // レスポンスの結果がfalseならエラーメッセージを表示
            if(!response.result){
              this.showAlertErrorHTML(response.message);
              return;
            }
            this.getApprovalWorkInfo();
            this.$emit("getApprovalCount");
          })
          .catch((e) => {
            // Note: エラーメッセージは、共通処理で表示している
            console.error(e);
          })
          .finally(() => {});
      });
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    },
    // リストからチェック
    // true：空
    // false：空ではない
    listEmptyCheck: function(list){
      if(list != null && list.length > 0){
        return false;
      }
      else{
        return true;
      }
    },
    // 出勤かチェックする
    // true：出勤
    // false：休み
    isAttendanceCheck: function(workSegment){
      const WORK_SEGMENT_HOLIDAY_TRANSFER = 11; // 休日出勤（振替）
      const WORK_SEGMENT_HOLIDAY_ALLOWANCE = 12; // 休日出勤（残業）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER = 21; // 公休出勤（振替）
      const WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE = 22; // 公休出勤（残業）

      if(workSegment != WORK_SEGMENT_HOLIDAY_TRANSFER
      && workSegment != WORK_SEGMENT_HOLIDAY_ALLOWANCE
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_TRANSFER
      && workSegment != WORK_SEGMENT_PUBLIC_HOLIDAY_ALLOWANCE
      && workSegment > 0){
        return false;
      }
      else{
        return true;
      }
    },
  },
};
</script>
<style>
.WorkM_ApprovalConditionArea {
  border-bottom: 1px solid rgb(212, 212, 212);
}

.Condition_StatusArea {
  display: flex;
  justify-content: space-around;
}
.Condition_StatusArea .StatusButton {
  /* width: 45%; */
  background: rgb(255, 255, 255);
  border: 1px solid silver;
  box-shadow: 2px 2px 2px silver;
  text-align: center;
  padding: 0.3rem;
  border-radius: 5px;
}

.WorkM_ApplicationHeader {
  display: flex;
  justify-content: center;
  padding: 1rem;
  font-size: 1.2rem;
}
.ConditionStartDate {
  width: 280px;
}

.WorkM_ApprovalWorkListArea {
  height: 100%;
}

.WorkM_ApprovalWorkItem {
  display: flex;
  margin-bottom: 0.7rem;
  background: rgb(227, 227, 227);
  box-shadow: 2px 2px 3px rgb(230, 230, 230);
  border-radius: 5px;
  height: 100%;
}
.WorkM_WorkApplicationItem_HeaderArea {
  font-size: 0.9rem;
  height: 100%;
  min-width: 4.5rem;
}
.SegmentLabel {
  padding: 4px;
  width: 100%;
  background: rgb(24, 103, 194);
  color: rgb(255, 255, 255);
  font-weight: 700;
  border-radius: 5px 0 0 0;
  min-width: 4rem;
  text-align: center;
}

.ApprovalWorkSelectArea {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ApprovalWorkSelectArea .ApprovalLabel {
  padding-left: 0.5rem;
  /* color: rgb(29, 116, 50); */
  text-align: left;
}
.ApprovalWorkSelectArea .RejectionLabel {
  padding-left: 0.5rem;
  /* color: red; */
  text-align: left;
}

.WorkM_ApprovalWorkItem_DetailArea {
  overflow:hidden;
  padding: 0.2rem 0.5rem;
  flex-grow: 1;
  background: #f5f5f5;
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem {
  display: flex;
  font-size: 0.95rem;
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem .WorkApplication_Transfer{
  color: rgb(29, 74, 124);
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem .WorkApplication_Allowance{
  color: rgb(167, 6, 6);
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem .WorkApplication_Overtime2{
  border: 1px solid green;
  color: green;
  margin:1px;
  background-color:transparent;
  padding: 0;
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem .WorkApplication_Transfer2{
  border: 1px solid rgb(29, 74, 124);
  color: rgb(29, 74, 124);
  margin:1px;
  background-color:transparent;
  padding: 0;
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDetailItem .WorkApplication_Allowance2{
  border: 1px solid rgb(167, 6, 6);
  color: rgb(167, 6, 6);
  margin:1px;
  background-color:transparent;
  padding: 0;
}
.WorkM_ApprovalWorkItem_DetailArea .ApprovalDate {
  font-size: 1.1rem;
  display: flex;
  font-weight: 700;
}
.WorkM_ApprovalWorkListArea .explainArea {
  font-size: 1rem; 
  padding: 0.25rem; 
  background-color: rgb(238, 238, 238);
}
</style>